import './App.css';
import Main from './components/amain';
// import Login from './components/login';



function App() {
  return (
    <div >
      <Main />
    </div>
  );
}

export default App;
